import React, { Component } from "react";
import { Button, Card, Col, Row, Badge, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { Link } from "react-router-dom";

export default class LinkedRequestsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      linkedRequests: [],
      pendingAssignments: [],
      activeView: "all",
      tableClms: [
        {
          name: "Link ID",
          selector: (row) => row.deploymentlinkedrequests_Id,
          sortable: true,
          width: "90px",
        },
        {
          name: "Parent Request",
          selector: (row) => row.parentRequest_Id,
          sortable: true,
          cell: (row) => (
            <span>
              #{row.parentRequest_Id}
              {row.requestCode && ` (${row.requestCode})`}
            </span>
          ),
        },
        {
          name: "Parent Type",
          selector: (row) => row.parentRequestType,
          cell: (row) => (
            <Badge bg={row.parentRequestType === "UI" ? "primary" : "success"}>
              {row.parentRequestType}
            </Badge>
          ),
          width: "110px",
        },
        {
          name: "Linked Type",
          selector: (row) => row.linkedRequestType,
          cell: (row) => (
            <Badge bg={row.linkedRequestType === "UI" ? "primary" : "success"}>
              {row.linkedRequestType || "Pending"}
            </Badge>
          ),
          width: "110px",
        },
        {
          name: "Linked Request",
          selector: (row) => row.linkedRequest_Id,
          cell: (row) =>
            row.linkedRequest_Id
              ? `#${row.linkedRequest_Id}`
              : "Not yet created",
        },
        {
          name: "Status",
          selector: (row) => row.linkStatus,
          cell: (row) => {
            const colors = {
              Pending: "warning",
              Accepted: "info",
              InProgress: "primary",
              Completed: "success",
              Rejected: "danger",
            };
            return (
              <Badge bg={colors[row.linkStatus] || "secondary"}>
                {row.linkStatus}
              </Badge>
            );
          },
          width: "110px",
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Reason",
          selector: (row) => row.reasonForDeployment,
          wrap: true,
        },
      ],
      pendingColumns: [
        {
          name: "Parent Request",
          selector: (row) => row.parentRequest_Id,
          cell: (row) => (
            <span>
              #{row.parentRequest_Id}
              {row.requestCode && ` - ${row.requestCode}`}
            </span>
          ),
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Need",
          selector: (row) => row.linkedRequestType,
          cell: (row) => (
            <Badge bg={row.linkedRequestType === "UI" ? "primary" : "success"}>
              {row.linkedRequestType ||
                (row.parentRequestType === "UI" ? "API" : "UI")}{" "}
              changes needed
            </Badge>
          ),
        },
        {
          name: "Reason",
          selector: (row) => row.reasonForDeployment,
          wrap: true,
        },
        {
          name: "Requested By",
          selector: (row) => row.requestedBy,
        },
        {
          name: "Actions",
          cell: (row) => (
            <Link
              to="/deploymentrequestpage"
              state={{
                crossTeamContext: {
                  linkId: row.deploymentlinkedrequests_Id,
                  parentRequestId: row.parentRequest_Id,
                  requestCode: row.requestCode,
                  projectName: row.projectName,
                  reasonForDeployment: row.reasonForDeployment,
                  requestedBy: row.requestedBy,
                  parentRequestType: row.parentRequestType,
                  // The team this developer must raise a request for
                  neededType:
                    row.linkedRequestType ||
                    (row.parentRequestType === "UI" ? "API" : "UI"),
                },
              }}
            >
              <Button size="sm" variant="primary">
                Raise Changes
              </Button>
            </Link>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchLinkedRequests();
    this.fetchPendingAssignments();
  }

  fetchLinkedRequests = () => {
    fetch(configData.api_url + "C_Deploymentlinkedrequests/list", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ linkedRequests: data.list });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  fetchPendingAssignments = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentlinkedrequests/pending", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ pendingAssignments: data.list });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  render() {
    return (
      <div className="container-fluid p-3">
        <h4>Linked Deployment Requests</h4>
        <p className="text-muted">
          View cross-team linked requests between UI and API teams
        </p>

        {/* Pending assignments alert */}
        {this.state.pendingAssignments.length > 0 && (
          <Card className="mb-3 border-warning">
            <Card.Header className="bg-warning">
              <strong>
                Your Pending Cross-Team Assignments (
                {this.state.pendingAssignments.length})
              </strong>
            </Card.Header>
            <Card.Body>
              <DataTable
                columns={this.state.pendingColumns}
                data={this.state.pendingAssignments}
                pagination
                highlightOnHover
                striped
              />
            </Card.Body>
          </Card>
        )}

        {/* All linked requests */}
        <Card>
          <Card.Header>
            <strong>All Linked Requests</strong>
          </Card.Header>
          <Card.Body>
            <DataTable
              columns={this.state.tableClms}
              data={this.state.linkedRequests}
              pagination
              highlightOnHover
              striped
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              paginationPerPage={100}
              keyField="id"
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
